const radians = Math.PI / 180;
const degrees = 180 / Math.PI;
export { degrees, radians };
//# sourceMappingURL=math.js.map
